import { gql } from '@/lib/graphql/gql'

export const ONBOARDING_BILLING_QUERY = gql`
  query OnboardingBillingDetails($idCompany: String!) {
    company(id: $idCompany) @live {
      id
      sevallaBilling {
        id
        address {
          name
          city
          country
          line1
          line2
          postalCode
          state
        }
      }
    }
  }
`

export const ONBOARDING_UPDATE_STRIPE_ADDRESS = gql`
  mutation OnboardingUpdateStripeAddress(
    $idCompany: String!
    $address: StripeAddressInput!
  ) {
    updateStripeAddress(idCompany: $idCompany, address: $address)
  }
`

export const CREATE_SETUP_INTENT = gql`
  mutation createSetupIntent(
    $idCompany: String!
    $idPaymentMethod: String!
    $setAsDefault: Boolean!
  ) {
    createStripeSetupIntent(
      idCompany: $idCompany
      idPaymentMethod: $idPaymentMethod
      setAsDefault: $setAsDefault
    )
  }
`

export const CONFIRM_SETUP_INTENT = gql`
  mutation confirmSetupIntent($idCompany: String!, $idSetupIntent: String!) {
    confirmStripeSetupIntent(
      idCompany: $idCompany
      idSetupIntent: $idSetupIntent
    )
  }
`
